export default __webpack_public_path__ + "PosAndroidDownload.png";